<template>
    <div>
        <member-write-link v-for="writeLayout in writeLayouts" :key="`memberComp${writeLayout}`" :writeLayout="writeLayout" :memberData="memberData"></member-write-link>
    </div>
</template>

<script>
import MemberWriteLink from "@/components/member/MemberWriteLink";
import memberUtil from "@/components/member/memberUtil";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import memberValidator from "@/mixins/validators/memberValidator";
import awsS3FileUpload from "@/mixins/awsS3FileUpload";
import {s3ApiDelete} from "../../plugins/awsS3Plugin";

export default {
    name: "MemberWriteComponent",
    mixins: [memberUtil, alertMixins, memberValidator, awsS3FileUpload],
    components: {MemberWriteLink},
    provide() {
        return {
            memberWriteSetData: this.setData,
            changeAllow: this.runChangeAllow,
        }
    },
    inject: ['changeLoading'],
    props: {
        memberType: {default: ''},
        memberKey: {default: 0},
        setNickName: {
            type: Function, default: () => {
            }
        },
        // boardKey: {default: 0},
    },
    data() {
        return {
            writeLayouts: [],
            getFunc: '',
            writeFunc: '',
            directUrl: '',
            writeSuccessType: '',
            keyName: '',
            writeKeyName: '',
            detailApiParamsSet: {},
            memberData: {},
            isRunning: false,
            fileInfo: [],
            validateCheck: [],
            essentialValidateCheck: [],
        }
    },
    created() {
        this.initFilterConfig();
        if (this.memberKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getMember();
        }
    },
    mounted() {
        EventBus.$on('createMember', this.checkValidator);
        EventBus.$on('updateMember', this.checkValidator);
        EventBus.$on('updateMemberPortfolio', this.checkValidator);
        EventBus.$on('updateCuratorType', this.updateMemberType);
        EventBus.$on('updateMemberType', this.updateMemberType);
        EventBus.$on('updateMemberMingle', this.updateMemberMingle);
    },
    beforeDestroy() {
        EventBus.$off('createMember');
        EventBus.$off('updateMember');
        EventBus.$off('updateMemberPortfolio');
        EventBus.$off('updateCuratorType');
        EventBus.$off('updateMemberType');
        EventBus.$off('updateMemberMingle');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initTemplateConfig() {
            let config = this.returnMemberConfig(this.memberType);
            this.writeLayouts = config.writeLayouts;
        },
        initFilterConfig() {
            let config = this.returnMemberConfig(this.memberType);
            this.getFunc = config.getFunc;
            this.writeFunc = config.writeFunc;
            this.directUrl = config.directUrl;
            this.writeApiParamSet = config.writeApiParamSet;
            this.writeSuccessType = config.writeSuccessType;
            this.parsingData = config.parsingData;
            this.detailApiParamsSet = config.detailApiParamsSet;
            this.fileInfo = config.fileInfo;
            this.validateCheck = config.validateCheck;
            this.essentialValidateCheck = config.essentialValidateCheck;
            this.keyName = config.keyName;
            this.writeKeyName = config.writeKeyName;
        },
        initSetData() {
            this.getFunc = '';
            this.writeFunc = '';
            this.directUrl = '';
            this.writeApiParamSet = {};
            this.writeSuccessType = '';
            this.parsingData = {};
            this.detailApiParamsSet = {};
            this.fileInfo = [];
            this.validateCheck = [];
            this.essentialValidateCheck = [];
            this.keyName = '';
            this.writeKeyName = '';
        },
        setData(type, value) {
            this[type] = value;
        },
        checkValidator() {
            if (this.isRunning) {
                return false;
            }
            let validatorArr = [];
            this.isRunning = true;

            //create,update 분기처리
            if (util.isEmpty(this.validateCheck)) {
                validatorArr = Object.keys(this.parsingData);
            } else {
                validatorArr = JSON.parse(JSON.stringify(this.essentialValidateCheck));
                let validatorArr_ = JSON.parse(JSON.stringify(this.validateCheck));
                validatorArr = JSON.parse(JSON.stringify(this.essentialValidateCheck));

                validatorArr_.forEach(key => {
                    if (util.isEmpty(this[key])) {
                        validatorArr.push(key)
                    }
                })
            }
            this.$validate(validatorArr).then(success => {
                if (success) {
                    this.writeMember();
                } else {
                    this.errorAlert('입력 정보를 확인해주세요.');
                    this.isRunning = false;
                }
            })
        },
        getMember() {
            this.writeLayouts = [];
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
            params[this.keyName] = this.memberKey;
            try {
                this.$api.$member[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (util.isEmpty(res.List)) {
                        this.createAlert({
                            content: '상세를 불러올 수 없습니다.',
                            hide: () => {
                                this.$router.back();
                            }
                        })
                    } else {
                        this.memberData = res.List[0];
                        EventBus.$emit("setMemberType", this.memberData.g_idx);
                        let isCurator = this.memberData.g_idx === 2
                        this.$localStorage.set('IsCurator', isCurator)
                        if (!util.isEmpty(this.memberData.mb_nick)) {
                            this.setNickName(this.memberData.mb_nick);
                        }
                        this.initTemplateConfig();
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        writeMember() {
            // let params = JSON.parse(JSON.stringify(this.writeApiParamSet));
            // if(this.writeFunc == 'updateMemberPortfolio'){
            //   params.mb_portfolio = this.portfolio;
            //   console.log(params.mb_portfolio)
            // }

            let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
            let dataArr = Object.keys(this.parsingData);
            if (this.memberType == 'detail') {
                // console.log(params)
                // console.log(dataArr)
            }
            // if((util.isEmpty(this.password) || util.isEmpty(this.passwordConfirm)) && util.isEmpty(this.portfolio)){
            //   dataArr.splice(dataArr.indexOf('password'), 1)
            //   dataArr.splice(dataArr.indexOf('passwordConfirm'), 1)
            // }
            // if(util.isEmpty(this.phone) && util.isEmpty(this.portfolio)){
            //   dataArr.splice(dataArr.indexOf('phone'), 1)
            // }
            dataArr.forEach(dataKey => {
                if (!util.isEmpty(this[dataKey])) {
                    params[this.parsingData[dataKey]] = this[dataKey];
                }
            })

            // if(this.memberType == 'portfolioEdit' || this.memberType == 'detail'){
            //   this.keyName = 'mb_no';
            // }
            if (this.writeFunc == 'createMember') {
                params.recommender = this.recommender;
            }
            if (this.memberKey != 0) {
                params[this.writeKeyName] = this.memberKey;
            }
            try {
                EventBus.$emit('apiLoading', true);
                this.$api.$member[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnType(res.Info.type);
                    if (type === true) {
                        if (!util.isEmpty(this.deleteFiles)) {
                            this.runS3ApiDeleteFiles(this.deleteFiles)
                        }
                        if (!util.isEmpty(this.fileInfo)) {
                            this.runUploadFileInfo(this.fileInfo, 0, this.memberKey).then(res => {
                                this.afterFunc();
                            });
                        } else {
                            this.afterFunc();
                        }
                    } else {
                        EventBus.$emit('apiLoading', false);
                        this.errorAlert(type);
                        this.isRunning = false;
                    }
                })
            } catch (e) {
                console.log(e);
                this.errorAlert('회원가입에 실패하였습니다.')
                EventBus.$emit('apiLoading', false);
                this.isRunning = false;
            }
        },
        afterFunc() {
            EventBus.$emit('apiLoading', false);
            this.createAlert({
                content: '저장되었습니다.',
                hide: () => {
                    this.isRunning = false;
                    if (this.memberType === 'create') {
                        // this.$router.back()
                    } else {
                        console.log('test')
                        this.getMember();
                        // this.getMember()
                    }

                }
            })
        },
        returnType(type) {
            switch (type) {
                case 1:
                    return true;
                case -222:
                    return '중복된 전화 번호 입니다.'
                default:
                    return '회원가입에 실패하였습니다.'
            }
        },
        runChangeAllow(type = 'allow', key) {
            if (type === 'allow') {
                this.allowMember(key);
            } else {
                this.refuseMember(key);
            }
        },
        allowMember(key) {
            let params = {
                c_idx: key,
            }
            try {
                this.changeLoading(true)
                this.$api.$member.approveCurator(params).then(res => res.Data.Result).then(res => {
                    this.changeLoading(false)
                    let type = this.returnAllowType(res.Info.type);
                    if (type === true) {
                        this.createAlert({
                            content: '승인되었습니다.',
                            hide: () => {
                                this.getMember()
                            }
                        })

                    } else {
                        this.errorAlert(type);
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        returnAllowType(type) {
            switch (type) {
                case 1:
                    return true;
                case  -202:
                    return '권한이 없습니다.'
                default:
                    return '보유아이템이 존재하거나 아이템 등록, 공모전 등록 이력이 존재합니다.';
            }
        },
        refuseMember(key) {
            let params = {
                c_idx: key,
            }
            try {
                this.changeLoading(true)
                this.$api.$member.refuseCurator(params).then(res => res.Data.Result).then(res => {
                    this.changeLoading(false)
                    if (res.Info.type === 1) {
                        this.createAlert({
                            content: '거절되었습니다.',
                        })
                    } else {
                        this.errorAlert('거절 실패하였습니다.');
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        updateMemberType(value, type) {
            let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
            params.mb_no = this.memberKey;
            if (type === 'curatorType') {
                if (value == 1) {
                    this.writeFunc = 'downgradeCurator'
                } else if (value == 2) {
                    this.writeFunc = 'upgradeCurator'
                }
                console.log(this.writeFunc)
            } else if (type === 'memberType') {
                params.mb_premium = value;
            }
            try {
                this.changeLoading(true)
                this.$api.$member[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    this.changeLoading(false)
                    this.writeFunc = 'updateMember';
                    if (res.Info.type === 1) {
                        this.createAlert({
                            content: '저장되었습니다.',
                            hide: () => {
                                this.getMember();
                            }
                        })
                    } else {
                        let alertText = this.returnCuratorType(res.Info.type);
                        this.errorAlert(alertText);
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        updateMemberMingle(type, price) {
            let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
            if (type == 'ADMINMINUS') {
                price = "-" + price
            }
            params.mb_no = this.memberKey;
            params.pd_code = type;
            params.p_point = price;
            params.p_reason = '';

            try {
                this.changeLoading(true)
                this.$api.$point.updatePoint(params).then(res => res.Data.Result).then(res => {
                    this.changeLoading(false)
                    if (res.type == 1 || res.Info.type == 1) {
                        let alertText = this.returnMingleType(type);
                        this.createAlert({
                            content: alertText,
                            hide: () => {
                                this.getMember();
                            }
                        })
                    } else {
                        this.errorAlert('저장 실패하였습니다.');
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        returnMingleType(type) {
            switch (type) {
                case 'ADMINPLUS':
                    return '지급되었습니다.';
                case 'ADMINMINUS':
                    return '차감되었습니다.';
            }
        },
        returnCuratorType(type) {
            switch (type) {
                case -214:
                    return '해당 회원은 큐레이터가 아닙니다.';
                case -253:
                    return '해당 회원이 보유한 아이템이 존재합니다.';
                case -215:
                    return '해당 회원이 큐레이션 중인 아이템이 존재합니다.';
                default:
                    return '변경 실패하였습니다.'
            }
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
